import { CustomerName } from 'constants/app.constants';
import { getSelectedDataZone } from './dataZone';
import { withHeaders } from './axiosInstance';
import { getElevatedSystemWalletId } from './userSettings';

type DefaultHeaderType = {
    BIQ_CUSTOMER_NAME: string | null;
    BIQ_SDZ_NAME: string;
    Authorization: string;
    BIQ_SYSTEM_WALLET_ID?: string;
};
export const getDefaultHeaders = (
    token: string,
    disableElevation: boolean = false
): DefaultHeaderType => {
    const elevatedSystemWalletId: string = getElevatedSystemWalletId();
    const defaultHeaders = {
        BIQ_CUSTOMER_NAME: CustomerName,
        BIQ_SDZ_NAME: getSelectedDataZone()?.sdz,
        Authorization: `Bearer ${token}`,
    };

    // return default headers if elevation is turned off and there's no elevated id, or if we need to turn off elevation for specific endpoints.
    if (!elevatedSystemWalletId || disableElevation) {
        return defaultHeaders;
    }

    return {
        ...defaultHeaders,
        BIQ_SYSTEM_WALLET_ID: elevatedSystemWalletId,
    };
};

export const getLifeGraphQueryCustomHeaders = (token: string): any => {
    const headers = getDefaultHeaders(token);
    return {
        ...headers,
        'Content-Type': 'text/plain',
        Accept: 'text/plain, */*',
    };
};

export const getDownloadFileCustomHeaders = (token: string): any => {
    const headers = getDefaultHeaders(token);
    return {
        ...withHeaders(headers),
        responseType: 'arraybuffer',
    };
};
